var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimeTablePhoneIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 6,
    fill: "#4FA6D1",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9937 24.4997L25.4697 20.432C25.0635 19.9633 24.3187 19.9654 23.8468 20.4383L20.9489 23.3414C20.0864 24.205 19.8395 25.4872 20.3385 26.5154C23.3193 32.6872 28.2968 37.6717 34.4645 40.6612C35.4916 41.1602 36.7728 40.9133 37.6353 40.0497L40.5603 37.1195C41.0343 36.6456 41.0353 35.8966 40.5624 35.4904L36.4791 31.9852C36.052 31.6185 35.3885 31.6664 34.9603 32.0956L33.5395 33.5185C33.4668 33.5947 33.371 33.645 33.2669 33.6615C33.1629 33.6781 33.0563 33.6601 32.9635 33.6102C30.641 32.2728 28.7145 30.3437 27.3801 28.0195C27.3302 27.9266 27.3121 27.8198 27.3286 27.7155C27.3452 27.6113 27.3955 27.5154 27.4718 27.4425L28.8885 26.0247C29.3176 25.5935 29.3645 24.9268 28.9937 24.4987V24.4997Z",
    stroke: "#4FA6D1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeTablePhoneIcon);
export default __webpack_public_path__ + "static/media/TimeTablePhoneIcon.4378a03541eb9d7250af06df6ed09a3a.svg";
export { ForwardRef as ReactComponent };